import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import StyleVariables, { getWidgetAttrSelector } from '../misc/StyleVariables';
import { baselineLayoutStyles } from './settings';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const useWidgetStyleVariables = _ref => {
  let {
    config,
    baseSettings,
    layoutSettings,
    isLargeContainer,
    isMediumContainer
  } = _ref;

  const globalVariables = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, baseSettings.styles || {}), layoutSettings.styles || {}), config.styles || {}), isMediumContainer || isLargeContainer ? _objectSpread(_objectSpread(_objectSpread({}, baseSettings.stylesMediumUp || {}), layoutSettings.stylesMediumUp || {}), config.stylesMediumUp || {}) : {}), isMediumContainer ? _objectSpread(_objectSpread(_objectSpread({}, baseSettings.stylesMedium || {}), layoutSettings.stylesMedium || {}), config.stylesMedium || {}) : {}), isLargeContainer ? _objectSpread(_objectSpread(_objectSpread({}, baseSettings.stylesLarge || {}), layoutSettings.stylesLarge || {}), config.stylesLarge || {}) : {});

  const stylesMainSections = appendSectionGroupBaselineVariables(globalVariables, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, layoutSettings.stylesMainSections || {}), config.stylesMainSections || {})), isMediumContainer || isLargeContainer ? _objectSpread(_objectSpread({}, layoutSettings.stylesMainSectionsMediumUp), config.stylesMainSectionsMediumUp) : {}), isMediumContainer ? _objectSpread(_objectSpread({}, layoutSettings.stylesMainSectionsMedium), config.stylesMainSectionsMedium) : {}), isLargeContainer ? _objectSpread(_objectSpread({}, layoutSettings.stylesMainSectionsLarge), config.stylesMainSectionsLarge) : {}));
  const stylesSidebarSections = layoutSettings.stylesSidebarSections ? appendSectionGroupBaselineVariables(globalVariables, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, layoutSettings.stylesSidebarSections || {}), config.stylesSidebarSections || {})), isMediumContainer || isLargeContainer ? _objectSpread(_objectSpread({}, layoutSettings.stylesSidebarSectionsMediumUp), config.stylesSidebarSectionsMediumUp) : {}), isMediumContainer ? _objectSpread(_objectSpread({}, layoutSettings.stylesSidebarSectionsMedium), config.stylesSidebarSectionsMedium) : {}), isLargeContainer ? _objectSpread(_objectSpread({}, layoutSettings.stylesSidebarSectionsLarge), config.stylesSidebarSectionsLarge) : {})) : undefined;
  return {
    globalVariables,
    stylesMainSections,
    stylesSidebarSections
  };
};

const WidgetStyleVariables = _ref2 => {
  let {
    widgetId,
    globalSettings = {},
    mainSectionsSettings = {},
    sidebarSectionsSettings,
    styles
  } = _ref2;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyleVariables, {
      selector: getWidgetAttrSelector(widgetId),
      data: globalSettings
    }), /*#__PURE__*/_jsx(StyleVariables, {
      selector: `${getWidgetAttrSelector(widgetId)} .${styles.main}`,
      data: mainSectionsSettings
    }), sidebarSectionsSettings ? /*#__PURE__*/_jsx(StyleVariables, {
      selector: `${getWidgetAttrSelector(`${widgetId}`)} .${styles.sidebar}`,
      data: sidebarSectionsSettings
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default WidgetStyleVariables; // Add section group variables conditionally
// based on the layouts settings & configs

function appendSectionGroupBaselineVariables(globalVariables, sectionGroupVariables) {
  const gridCellMaxHeight = sectionGroupVariables.gridCellMaxHeight || globalVariables.gridCellMaxHeight; // Ensure that charts never have auto height

  if (gridCellMaxHeight === 'auto') {
    sectionGroupVariables.chartGridCellBaseHeight = baselineLayoutStyles.chartAutoHeight;
  }

  return sectionGroupVariables;
}